import { FC } from "react";

import { PrescriberInfoProps } from "./types";
import { CASE_CATEGORY, CASE_REVIEW_TYPES, DEFAULT_DRUG_NAME } from "src/constants/cases";
import { format } from 'date-fns';

const ShowPrescriberInformation: FC<PrescriberInfoProps> = ({ getValues }): JSX.Element => {
  const { prescription_attributes, category } = getValues();

  return (
    <div className="card my-3">
      <div className="card-header">
        <h1 className="m-0">Prescription Information</h1>
      </div>
      <div className="card-body">
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Drug:</label>
              </div>
              <div className="col-6">
                {prescription_attributes && prescription_attributes.drug_name && prescription_attributes.drug_name }
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Benefits being requested:</label>
              </div>
              <div className="col-6">
                <p>{category ? CASE_CATEGORY[category as ("rx" | "med" | "medrx")] : "N/A"}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Review Type:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.review_type ? CASE_REVIEW_TYPES.find((item) => item.value === prescription_attributes.review_type)?.name  : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Condition:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.condition ? prescription_attributes.condition  : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Quantity:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.injection_site ? prescription_attributes.injection_site : '0'}</p>
              </div>
            </div>
          </div>
          {prescription_attributes.drug_name === "Furoscix ReadyFlow Autoinjector" &&
          <>
           {prescription_attributes.frequency_of_use  &&  <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Frequency:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.frequency_of_use ? prescription_attributes.frequency_of_use : 'N/A'}</p>
              </div>
            </div>
          </div>}
          {/* {prescription_attributes.frequency_of_use === "Other" && (
            <div className="col-lg-6 col-md-6 col-12">
              <div className="row">
                <div className="col-6">
                  <label className="form-label">Frequency:</label>
                </div>
                <div className="col-6">
                  <p>{prescription_attributes && prescription_attributes.frequency_of_use && prescription_attributes.other_frequency_of_use ?prescription_attributes.frequency_of_use + " - " + prescription_attributes.other_frequency_of_use : 'N/A'}</p>
                </div>
              </div>
            </div>
         )} */}
          {/* { prescription_attributes.daily_dose !== "Other" && <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Daily Dose:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.daily_dose ? prescription_attributes.daily_dose : ''}</p>
              </div>
            </div>
          </div>} */}
          {/* {prescription_attributes.daily_dose === "Other" && (
            <div className="col-lg-6 col-md-6 col-12">
              <div className="row">
                <div className="col-6">
                  <label className="form-label">Daily Dose:</label>
                </div>
                <div className="col-6">
                  <p>{prescription_attributes && prescription_attributes.daily_dose && prescription_attributes.other_daily_dose ? prescription_attributes.daily_dose + " - " + prescription_attributes.other_daily_dose : 'N/A'}</p>
                </div>
              </div>
            </div>
         )} */}
          </>}
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Refills:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.refills_authorized ? prescription_attributes.refills_authorized : '0'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Diagnosis Code (ICD):</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes?.diagnosis_code?.length > 0  ? prescription_attributes.diagnosis_code.join(", ") : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Notes:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.note ? prescription_attributes.note : 'N/A'}</p>
              </div>
            </div>
          </div>
          {prescription_attributes.drug_name === "Furoscix ReadyFlow Autoinjector" && 
          <>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Supervising MD Name:</label>
              </div>
              <div className="col-6">
                <span>{prescription_attributes && prescription_attributes.supervising_md_firstname ? prescription_attributes.supervising_md_firstname : 'N/A'}</span>
                {" "}
                <span>{prescription_attributes && prescription_attributes.supervising_md_lastname ? prescription_attributes.supervising_md_lastname : 'N/A'}</span>
              </div>
            </div>
          </div>
          </>}
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Anticipated Date of Service:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.scheduled_date_of_service ? format(new Date(prescription_attributes.scheduled_date_of_service), 'MM/dd/yyyy') : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Directions:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.direction ? prescription_attributes.direction : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Written Date:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.written_date ? prescription_attributes.written_date : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowPrescriberInformation;
